
import Slidetify from "@/components/Slidetify.vue";
import Util from "@/ts/Util";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Slidetify,
  },
  props: {
    notificationsIcon: String,
    notificationsKey: Number,
    tourHomeTop: String,
    isTour: Boolean,
    iconActive: String,
    pageTitle: String,
    imgLogo: String,
    showBack: Boolean,
    userData: [Array, Object],
    openSideMenu: Function,
  },
})
export default class HeaderHome extends Vue {
  ORG_DATA: any = JSON.parse(
    sessionStorage.getItem("ORGANIZATION_DATA") || "{}"
  );
  LOGO: any = this.ORG_DATA.CONFIGURATIONS.LOGO_IMAGE_SMALL;
  userHasNotifications: any = JSON.parse(
    sessionStorage.getItem("USER_HAS_NOTIFICATIONS") || "false"
  );
  optionsTour: any = [
    { name: "Usuario", icon: "bars" },
    { name: "Notificacao", icon: "bell" },
    { name: "Qrcode", icon: "qrcode" },
  ];
  logo = sessionStorage.getItem("ORGANIZATION_LOGO") || "";
  homeLayout = sessionStorage.getItem("HOME_LAYOUT") || "feed";
  rotaAtual = "";

  get differentFromHome() {
    return this.$route.name != this.homeLayout;
  }

  mounted() {
    this.rotaAtual = this.$route.path;
    if (sessionStorage.getItem("IDTABLE")) {
      this.$route.params.idTable = JSON.parse(
        sessionStorage.getItem("IDTABLE") || "null"
      );
    }
  }

  goToNotifications() {
    this.$router.push("Notifications");
  }

  buttonClickEvent() {
    this.$emit("buttonCallBack");
  }

  backbuttonEvent() {
    const self = this;
    Util.setBackButtonBehavior(function () {
      $(".sidenav").sidenav("close");
    });
    $(".sidenav").sidenav({
      onCloseStart: self.goHome,
    });
  }

  goHome() {
    const self = this;
    let homeLayout = this.verifyRouteHome();
    Util.setBackButtonBehavior(function () {
      self.$router.push("HomeFeed");
    });
  }

  verifyRouteHome() {
    let util: any = new Util();
    let homeLayout: any = util.verifyRouteHome();
    return homeLayout;
  }

  goBack() {
    const honestMarket: any = sessionStorage.getItem("honestMarket") || "false";
    const lastRoute: any =
      sessionStorage.getItem("WHICH_ROUTE_CAME_TO_PEDIDO") || "false";
    if (this.$route.params.idTable) {
      if (lastRoute == '"/BarCodeProduct"') {
        this.$router.push({
          name: "BarCodeProduct",
          params: {
            idStore: this.$route.params.idStore,
            idTable: this.$route.params.idTable,
          },
        });
      } else if (lastRoute == '"/Produtos"') {
        this.$router.push({
          name: "Produtos",
          params: {
            idStore: this.$route.params.idStore,
            idTable: this.$route.params.idTable,
          },
        });
      } else if (lastRoute == '"/ListaDeProdutos"') {
        this.$router.push({
          name: "ListaDeProdutos",
          params: {
            idStore: this.$route.params.idStore,
            idTable: this.$route.params.idTable,
          },
        });
      } else {
        this.$router.go(-1);
      }
    } else {
      if (honestMarket == "true" && lastRoute == '"/BarCodeProduct"') {
        this.$router.push("BarCodeProduct");
      } else if (honestMarket == "true" && lastRoute == '"/ListaDeProdutos"') {
        this.$router.push("ListaDeProdutos");
      } else {
        this.$router.go(-1);
      }
    }
  }
}
